import React, { forwardRef, useImperativeHandle, useState, useCallback } from 'react';
import { Button } from "../../bootstrap/index.jsx";
import DropdownMenu from '../../common/DropdownMenu.jsx';

const MENU_ITEM_STYLE = {
  display: 'grid', 
  gridTemplateColumns: '20px 1fr', 
  padding: '0.5rem 3rem'
};

const IndicatorToolbar = ({gridRef, ...rest}) => {

  return null //TODO

  const menuItems = <>
    <li style={MENU_ITEM_STYLE}><span>+</span> Join grid</li>
    <li style={MENU_ITEM_STYLE}>
      <span>+</span>
      <span>
        <p style={{marginBottom: 0}}>Add another grid </p>
        <span className='description'>Aggregate indicator</span>
      </span>
    </li>
  </>

  return  <div style={{margin: '1rem 0'}}>
    <Button size='sm' type='default' className='mr-1'>Add formula column</Button>
    <DropdownMenu menuItems={menuItems}>
      <Button size='sm' type='default'>Add grid</Button>
    </DropdownMenu>
  </div>
}

export default IndicatorToolbar;